/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect, useRef, useState } from 'react';

import { UseScrollTriggerOptions } from './types';

function defaultTrigger(store: any, options: any): boolean {
  const { disableHysteresis = false, threshold = 100, target } = options;
  const previous = store.current;

  if (target) {
    // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

const defaultTarget = typeof window !== 'undefined' ? window : null;

export default function useScrollTrigger(options = {} as UseScrollTriggerOptions): boolean | string {
  const { getTrigger = defaultTrigger, target = defaultTarget, ...other } = options;
  const store = useRef();
  const [trigger, setTrigger] = useState(() => getTrigger(store, other));

  useEffect(() => {
    const handleScroll = () => {
      setTrigger(getTrigger(store, { target, ...other }));
    };

    handleScroll(); // Re-evaluate trigger when dependencies change
    target?.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      target?.removeEventListener('scroll', handleScroll, {
        passive: true,
      } as unknown as EventListenerOptions);
    };
  }, [target, getTrigger, JSON.stringify(other)]);

  return trigger;
}
